export default {
  BASE_URL: '/pub/dict',
  api: [
    {
      name: 'list',
      desc: '获取字典列表',
      method: 'GET',
      path: '/page/list'
    },
    {
      name: 'nameList',
      desc: '获取字典名称列表',
      method: 'GET',
      path: '/name/list'
    },
    {
      name: 'saveDict',
      desc: '编辑新增字典保存',
      method: 'POST',
      path: '/save'
    },
    {
      name: 'delDict',
      desc: '删除字典',
      method: 'DELETE',
      path: '/del'
    },
    {
      name: 'isEnable',
      desc: '启用停用',
      method: 'POST',
      path: '/isEnable'
    },
    {
      name: 'professionalDictType',
      desc: '获取专业领域字典列表',
      method: 'GET',
      path: '/list?dictType=20'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/system/dictionary/index.js